import { SPIFF_RULE_EVENTS } from "@/spiff-rules/constants";
import type { SpiffRuleEvent } from "@/spiff-rules/spiff-rule";

export const REVIEW_PLATFORM_TO_DISPLAY = {
  google: "Google",
  yelp: "Yelp",
  facebook: "Facebook",
  tripadvisor: "TripAdvisor",
};

// Raw event names that we accept from the activity feed API
export const ACTIVITY_FEED_EVENTS = {
  signup: "signup",
  referral_creation: "referral_creation",
  referral_completion: "referral_completion",
  review: "review",
  five_star_review: "five_star_review",
  yard_sign_photo: "yard_sign_photo",
  pricebook_item_sale: "pricebook_item_sale",
  tech_generated_lead: "tech_generated_lead",
  driving_score: "driving_score",
  generic: "generic",
} as const;

// Precomputed Set of allowed activity events for efficient filtering
export const ALLOWED_ACTIVITY_EVENTS = new Set<string>(
  Object.values(ACTIVITY_FEED_EVENTS).filter(
    (eventName) => eventName !== ACTIVITY_FEED_EVENTS.review,
  ),
);

export const ACTIVITY_FEED_EVENT_TO_SPIFF_EVENT = {
  review: SPIFF_RULE_EVENTS.five_star_review,
  five_star_review: SPIFF_RULE_EVENTS.five_star_review,
} as const;

export const getSpiffEventName = (
  activityEventName: string,
): SpiffRuleEvent => {
  const mapped =
    ACTIVITY_FEED_EVENT_TO_SPIFF_EVENT[
      activityEventName as keyof typeof ACTIVITY_FEED_EVENT_TO_SPIFF_EVENT
    ];
  return (mapped || activityEventName) as SpiffRuleEvent;
};

export const ALLOWED_SPIFF_EVENTS = new Set<string>(
  Object.values(SPIFF_RULE_EVENTS),
);
